<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nVGelj/tc-custom/9781399078115.jpg?1729185237937" alt="This image is the cover for the book Great War Fighter Aces, 1914–1916, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great War Fighter Aces, 1914–1916, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>Here, Norman Franks tells the story, in words and images, of the emergence of some of the greatest fighter aces to see action during the first half of the First World War. He explores the manner in which the situation developed from late 1914 to the late summer of 1916, the point at which Oswald Boelcke helped form the German Jasta system that would prove so devastating to the RFC and RNAS.  Utilizing images drawn from his large personal archive of photographs, Franks profiles some of the greatest and most notorious aces, as well as the aircraft in which they flew. The first years of the war saw some of the bravest acts of pilot gallantry and ingenuity play out. Franks celebrates the legacy of just a handful of these individuals, participants on both sides, including Boelcke's premier ace Manfred Von Richtofen, Lanoe Hawker, Georges Guynemer, Albert Ball, Lionel Rees, Wilhelm Frankl, and Stanley Dallas amongst many others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norman Franks
      </h2>
      
      <p class="authorDescription body article">Norman Franks is a respected historian and author.  Previous titles for Pen and Sword include InThe Footsteps of the Red Baron (co-authored with Mike OConnor), The Fighting Cocks, RAF Fighter Pilots Over Burma, Dogfight, The Fallen Few of the Battle of Britain (with Nigel McCrery) and Dowdings Eagles.  Over the course of his career, Frank has published some of the most compelling works on First World War fighter aviation, being one of the worlds leading authorities on the subject. He lives in Bexhill-on-Sea, East Sussex.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Aviation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59597cf7